'use strict';
export const GlobalConstants = Object.freeze({
  BSEC: 'a70mx8',
  MAX_ALLOWED_CHARS_FOR_PO: 42,
});
